/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Short_Shipment_Already_CreditedInputs */

const en_error_short_shipment_already_credited = /** @type {(inputs: Error_Short_Shipment_Already_CreditedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The credit note of this shipment is already approved or recorded.`)
};

/**
* | output |
* | --- |
* | "The credit note of this shipment is already approved or recorded." |
*
* @param {Error_Short_Shipment_Already_CreditedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_short_shipment_already_credited = /** @type {((inputs?: Error_Short_Shipment_Already_CreditedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Short_Shipment_Already_CreditedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_short_shipment_already_credited(inputs)
});